export default __webpack_public_path__ + "static/bncff-web-site-1-mobile-c710cf2b30c44a373aa14c313e9454f5.jpg";